import React, { useMemo } from "react";
import Image from "next/image";
import contactStyle from '../../../styles/sass/contact.module.scss'
import BannerInner from "../../common-components/bannerinner/BannerInner";
import bannerImage from "../../../../public/assets/images/banner-img-top-6.jpg";
import mapImage from "../../../../public/assets/images/map-location.jpg";
import mailIcon from "../../../../public/assets/images/c-mail-icon.svg";
import telIcon from "../../../../public/assets/images/c-tel-icon.svg";
import locationIcon from "../../../../public/assets/images/c-location-icon.svg";
import Tourform from "../../utils/Tourform";


const Contact = () => {


  return (
    <>
      <BannerInner title={"Contact us"} imageSrc={bannerImage} />
      <section className={`mc_container_fluid p-spacerT p-spacerB ${contactStyle["c-o-cb"]}`}>
        <div className="mc_row_new">
          <div className="mc_container_inner">
            <div className="mc_row_new">
              <div className={`${contactStyle["c-col-o-cb"]}`}>
                <div className={`${contactStyle["c-col-i-cb"]} pos-rel`}>
                  <Image
                      src={mapImage?.src}
                      objectFit="cover"
                      layout="fill"
                      priority={true}
                      alt={"Map Location"}
                  />
                </div>
                <div className={`${contactStyle["c-col-a-o-cb"]} pos-rel`}>
                  <div className={`${contactStyle["c-col-a-i-cb"]} pos-rel`}>
                    <ul>
                      <li>
                        <span>
                          <Image
                          src={locationIcon?.src}
                            width={18}
                            height={26}
                            priority={false}
                          alt={"Map Location icon"}
                      />
                        </span>
                        <p>37 Tanner Street SE1 3LF(off Bermondsey Street) and Tower Bridge Road SE1 3JB</p>
                      </li>

                      <li>
                        <span>
                          <Image
                          src={mailIcon?.src}
                            width={33}
                            height={26}
                            priority={false}
                          alt={"Mail icon"}
                      />
                        </span>
                        <p><a href="mailto:info@go-bermondsey.co.uk">info@go-bermondsey.co.uk</a></p>
                      </li>

                      <li>
                        <span>
                          <Image
                          src={telIcon?.src}
                            width={26}
                            height={26}
                            priority={false}
                          alt={"Tel icon"}
                      />
                        </span>
                        <p><a href="tel:+44 (0) 203 465 9123">+44 (0) 203 465 9123</a></p>
                      </li>
                    
                    </ul>
                  </div>
                </div>
              </div>  
            </div>

            {/* contact form */}
            <div className="mc_row_new">
              <div className={`${contactStyle["c-col-form-cb"]}`}>
              <div className="c-text-container">
                  <h2 className={`${contactStyle["c-form-heading-cb"]}`}>Interested in having an office space in GO (Garden Office) Bermondsey?</h2>
                  <p>Complete the form below, let us know your office requirements, a member of our team will reach out to learn more about your office spaces need and finds you the best private office or meeting room in the Tanner Street to run your business.</p>
              </div>
              <div>
                  <Tourform setField={false} pageName={"Contact Us"} />
                </div>
                </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default React.memo(Contact);